import { useQuery, useMutation } from 'react-query'
import axios from 'axios'

const fetchSchedule = async (branchId, isHome) => {
  const routeParam = isHome ? 'home' : branchId

  if (!routeParam) throw new Error('Branch ID is required')

  const { data } = await axios.get(
    `${process.env.NEXT_PUBLIC_API_ROOT}/api/inspection_options/${routeParam}/schedule`,
  )
  return data?.regular_schedule || []
}

const fetchBranches = async () => {
  const { data } = await axios.get(
    `${process.env.NEXT_PUBLIC_API_ROOT}/api/branches`,
  )
  return data || []
}

const useSchedule = () => {
  const getScheduleByBranch = (branchId, isHome = false, enabled) => {
    return useQuery(
      ['schedule_branch', { branchId, isHome }],
      () => fetchSchedule(branchId, isHome),
      {
        enabled: enabled && (!!branchId || isHome),
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        refetchOnReconnect: false,
        retry: false,
        staleTime: 1000 * 60 * 5,
      },
    )
  }

  const getBranches = (enabled = true) => {
    return useQuery(
      ['branches_list'],
      fetchBranches,
      {
        enabled,
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        staleTime: 1000 * 60 * 60,
      },
    )
  }

  const getTimes = (schedules, dateSelected) => {
    if (!Array.isArray(schedules) || !dateSelected) return []
    const selectedDay = schedules.find((item) => item?.week_day === dateSelected)
    return selectedDay ? selectedDay.hours : []
  }

  return {
    getScheduleByBranch,
    getBranches,
    getTimes,
  }
}

const useCreateSchedule = () => useMutation(async ({ branchId, data, isHomeSchedule }) => {
  const dataSend = {
    date_time: data.date_time,
    sell_your_car_report_id: data.sell_your_car_report_id,
  }
  if (isHomeSchedule) {
    dataSend.address = data.address
  }
  const branch = branchId || data?.branch_id
  const req = await axios.post(
    isHomeSchedule
      ? `${process.env.NEXT_PUBLIC_API_ROOT}/api/inspection_options/home/appointment`
      : `${process.env.NEXT_PUBLIC_API_ROOT}/api/inspection_options/${branch}/appointment`,
    { ...dataSend },
  )
  return req.data
})

export { useSchedule, useCreateSchedule }
